import React from 'react'
import useGAViews from '../Hooks/useGAViews'

const GoogleAnalytics = () => {
    useGAViews()

    return <></>
}
export default GoogleAnalytics